(function () {
  'use strict';

  var STORAGE_KEY = 'hs_recent_searches';
  var MAX_RECENT = 5;
  // Cache: null = not yet fetched, [] = fetched but empty, [...] = products
  var bestSellersCache = null;
  var fetchPromise = null;

  /* ---------- Money helper ----------
   * Shopify /collections/all/products.json returns price as a STRING like "44.90"
   * (already in store currency, not cents). We prepend the currency symbol.
   */
  function formatPrice(priceStr) {
    if (!priceStr && priceStr !== 0) return '';
    var symbol = (window.currencySymbol) || '$';
    return symbol + String(priceStr);
  }

  /* ---------- Shopify CDN image resize ---------- */
  function cdnResize(url, size) {
    if (!url || typeof url !== 'string') return '';
    // Insert _SIZExSIZE before the file extension and before any query string
    return url.replace(/(_\d+x\d*)?(\.(jpg|jpeg|png|gif|webp))(\?|$)/i,
      '_' + size + '$2$4');
  }

  /* ---------- HTML escape ---------- */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ---------- Recent searches ---------- */
  function getRecent() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function saveRecent(term) {
    if (!term || !term.trim()) return;
    var t = term.trim();
    try {
      var list = getRecent().filter(function (s) { return s.toLowerCase() !== t.toLowerCase(); });
      list.unshift(t);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_RECENT)));
    } catch (e) {}
  }

  var CLOCK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="icon-search-1" aria-hidden="true" style="width:16px;height:16px;opacity:.55;flex-shrink:0;"><path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/></svg>';
  var SEARCH_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="icon-search-1" aria-hidden="true"><path d="M 19 3 C 13.49 3 9 7.49 9 13 C 9 15.39 9.84 17.59 11.25 19.31 L 3.28 27.28 L 4.72 28.72 L 12.69 20.75 C 14.41 22.16 16.61 23 19 23 C 24.51 23 29 18.51 29 13 C 29 7.49 24.51 3 19 3 Z M 19 5 C 23.43 5 27 8.57 27 13 C 27 17.43 23.43 21 19 21 C 14.57 21 11 17.43 11 13 C 11 8.57 14.57 5 19 5 Z"/></svg>';

  function searchUrl(term) {
    return '/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(term);
  }

  function renderRecentSearches(container) {
    var section = container.querySelector('[data-recent-section]');
    var list = container.querySelector('[data-recent-list]');
    if (!section || !list) return;
    var items = getRecent().slice(0, 3);
    if (items.length === 0) { section.style.display = 'none'; return; }
    list.innerHTML = items.map(function (t) {
      return '<li class="item"><a href="' + searchUrl(t) + '" class="link">' + CLOCK_SVG + '<span class="text">' + esc(t) + '</span></a></li>';
    }).join('');
    section.style.display = '';
  }

  /* ---------- Product card ---------- */
  function buildCard(product) {
    // /collections/all/products.json: featured_image is usually null;
    // images is an array of objects with .src  (NOT plain strings)
    var rawUrl = '';
    if (product.featured_image && typeof product.featured_image === 'string') {
      rawUrl = product.featured_image;
    } else if (product.images && product.images.length > 0) {
      rawUrl = (typeof product.images[0] === 'string') ? product.images[0] : (product.images[0].src || '');
    }
    var imgSrc = rawUrl ? cdnResize(rawUrl, '400x400') : '';

    // Price is in variants[0].price as a pre-formatted STRING like "44.90"
    var variant = product.variants && product.variants[0];
    var priceStr = (variant && variant.price) ? variant.price : '0';
    var compareStr = (variant && variant.compare_at_price) ? variant.compare_at_price : null;
    var price = formatPrice(priceStr);
    var saleHtml = (compareStr && parseFloat(compareStr) > parseFloat(priceStr))
      ? '<dd class="price__compare"><span class="price-item price-item--compare" style="text-decoration:line-through;color:#aaa;margin-right:5px;">' + formatPrice(compareStr) + '</span></dd>'
      : '';

    return '<div class="product">'
      + '<div class="product-item">'
      + '<div class="card">'
      + '<a href="/products/' + esc(product.handle) + '">'
      + '<div class="card-media" style="position:relative;overflow:hidden;padding-top:100%;">'
      + (imgSrc
          ? '<img src="' + imgSrc + '" alt="' + esc(product.title) + '" loading="lazy" width="400" height="400" style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;">'
          : '<div style="position:absolute;top:0;left:0;width:100%;height:100%;background:#f5f5f5;"></div>')
      + '</div>'
      + '<div class="card-information" style="font-size:var(--font-body-size,13px);padding:8px 0 0;">'
      + '<h4 class="card-title" title="' + esc(product.title) + '" style="margin:0 0 4px;font-size:inherit;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;">' + esc(product.title) + '</h4>'
      + '<div class="card-price"><dl class="price" style="margin:0;display:flex;flex-wrap:wrap;align-items:center;">'
      + saleHtml
      + '<dd class="price__regular"><span class="price-item price-item--regular">' + price + '</span></dd>'
      + '</dl></div>'
      + '</div>'
      + '</a>'
      + '</div>'
      + '</div>'
      + '</div>';
  }

  /* ---------- Fetch best sellers ---------- */
  function fetchBestSellers() {
    if (bestSellersCache !== null) return Promise.resolve(bestSellersCache);
    if (fetchPromise) return fetchPromise;

    // Try the Shopify AJAX collections endpoint
    var url = '/collections/all/products.json?sort_by=best-selling&limit=3';

    fetchPromise = fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        bestSellersCache = (data && Array.isArray(data.products)) ? data.products : [];
        fetchPromise = null;
        return bestSellersCache;
      })
      .catch(function (err) {
        fetchPromise = null;
        bestSellersCache = null; // allow retry
        throw err;
      });

    return fetchPromise;
  }

  /* ---------- Init one container ---------- */
  function initContainer(container) {
    if (container._hsInit) return; // prevent double-init
    container._hsInit = true;

    renderRecentSearches(container);

    var section = container.querySelector('[data-best-sellers-section]');
    var grid = container.querySelector('[data-best-sellers-grid]');
    if (!section || !grid) return;

    fetchBestSellers()
      .then(function (products) {
        if (!products || products.length === 0) {
          section.style.display = 'none';
          return;
        }
        grid.innerHTML = products.map(buildCard).join('');
        section.style.display = '';
      })
      .catch(function () {
        section.style.display = 'none';
      });
  }

  /* ---------- Re-render recent searches on search focus ---------- */
  function onSearchFocus(e) {
    var input = e.target;
    if (!input || input.tagName !== 'INPUT' || (input.type !== 'search' && input.name !== 'q')) return;

    // Find all trending blocks visible/hidden in current scope
    document.querySelectorAll('[data-quick-trending-products]').forEach(function (c) {
      renderRecentSearches(c);
    });
  }

  /* ---------- Track searches ---------- */
  function onFormSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = (form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('search') === -1) return;
    var input = form.querySelector('input[name="q"]');
    if (input && input.value.trim()) saveRecent(input.value.trim());
  }

  function onPredictiveClick(e) {
    var link = e.target.closest ? e.target.closest('[data-predictive-search] li a') : null;
    if (!link) return;
    var el = link.querySelector('.h5, .card-title, [class*="heading"]');
    if (el && el.textContent.trim()) saveRecent(el.textContent.trim());
  }

  /* ---------- Watch for dynamically added containers ---------- */
  function watchDOM() {
    if (!window.MutationObserver) return;
    var obs = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-quick-trending-products]')) {
            initContainer(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('[data-quick-trending-products]').forEach(initContainer);
          }
        });
      });
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Bootstrap ---------- */
  function boot() {
    document.querySelectorAll('[data-quick-trending-products]').forEach(initContainer);
    document.addEventListener('focusin', onSearchFocus);
    document.addEventListener('submit', onFormSubmit, true);
    document.addEventListener('click', onPredictiveClick);
    watchDOM();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
